<template>
	<div>
		<!-- <buttonlist  @exps="exps"  @search="search" @reflash="reflash" ref="SetBtn"></buttonlist> -->
		<!-- <el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini"  @click="send">获取数据</el-button>
				</div>
			</div>
		</el-card> -->
<!-- <div style="display: flex;background: white">
		<el-card class="box-card" style="width: 20%;">
		<div slot="header" class="clearfix">
		<span>卡片名称</span>
		</div>
		<div v-for="o in 4" :key="o" class="text item">
		{{'列表内容 ' + o }}
		</div>
		</el-card>
		<el-card class="box-card" style="width: 20%;">
		<div slot="header" class="clearfix">
		<span>卡片名称</span>
		</div>
		<div v-for="o in 4" :key="o" class="text item">
		{{'列表内容 ' + o }}
		</div>
		</el-card>
</div>		 -->
	<el-card class="box-card">
	<div style="display: flex;background: white">
	<div style="width: 50%;text-align: left;display: flex">
	<el-button type="primary" size="mini"  @click="NewForm()" :disabled="!btn.btn1">{{$t('getapi[7277]')}}</el-button>
	<el-button type="primary" size="mini"  @click="AuditMonth()" :disabled="!btn.btn2">{{$t('getapi[7278]')}}</el-button>
	<el-button type="primary" size="mini"  @click="InvAuditMonth()" :disabled="!btn.btn3">{{$t('getapi[7279]')}}</el-button>
	<el-button type="primary" size="mini"  @click="BiaodingMonth()" :disabled="!btn.btn4">{{$t('getapi[7280]')}}</el-button>
	<el-button type="primary" size="mini"  @click="InverseThisMonth()" :disabled="!btn.btn5">{{$t('getapi[7281]')}}</el-button>
	<el-button type="primary" size="mini"  @click="ClearBiaoding()" :disabled="!btn.btn6">{{$t('getapi[7282]')}}</el-button>
	</div>
	</div>
	</el-card> 
 <el-divider content-position="left">{{$t('getapi[7283]')}}</el-divider>
		<table>
		<tr>
		<td style="width:60px;text-align: right"  >{{ $t('getapi[1974]') }}:</td>
		<td style="width:150px;">
		<el-select filterable v-model="dataDetail.cboyear"  size="mini" style="margin-righ:20px">
		<el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
		</el-select>
		</td>
		<td style="width:60px">{{IsCaculate}}</td>

		</tr>
		<tr>
		<td style="width:60px;text-align: right">{{ $t('getapi[1975]') }}:</td>
		<td style="width:150px;">
		<el-select filterable v-model="dataDetail.cbomonth"  size="mini" style="margin-righ:20px" @change="getMonthData()">
		<el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
		</el-select>
		</td>
		<td style="width:60px">{{IsSure}}</td>

		</tr>
		</table>

 <el-divider content-position="left">{{$t('getapi[7284]')}}</el-divider>
 <el-button type="primary" size="mini" @click="doCaculate" :loading="loading">{{$t('getapi[7276]')}}</el-button>

 <!-- <el-button type="info" size="mini" @click="doVerify">停止计算</el-button> -->
 <el-divider content-position="left">{{$t('getapi[7272]')}}</el-divider>
 <table>
		<tr>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7285]')}}</td>
		<td style="width:150px;">
		{{txt1}}
		</td>
		<td style="width:60px"></td>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7286]')}}</td>
		<td style="width:150px;">
		{{txt2}}
		</td>
		</tr>
		<tr>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7273]')}}</td>
		<td style="width:150px;">
		{{txt3}}
		</td>
		<td style="width:60px"></td>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7274]')}}</td>
		<td style="width:150px;">
		{{txt4}}
		</td>
		</tr>

		<tr>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7275]')}}</td>
		<td style="width:150px;">
		<span style="font-weight:bold">{{txt5}}</span>
		</td>

		<td style="width:60px"></td>
		<td style="width:150px;text-align: right"  ></td>
		<td style="width:150px;">
		</td>

		</tr>
		<tr>
		<td style="width:150px;text-align: right"  >
			<el-checkbox v-model="IsNew">{{$t('getapi[7287]')}}</el-checkbox>
		</td>
		
		</tr>
		</table>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_costcompute',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight-240,
                maxHeight: this.$windowSize.tableHeight-240,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight-180
        }
    },
	data() {
		return {
			IsNew:true,
			IsCaculate:'未计算',
			IsSure:'未标定',
			dataDetail:{
                    cboyear: '',
                    cbomonth: '',
                },
			yearList:[],
			txt1:'/',
			txt2:'/',
			txt3:'/',
			txt4:'/',
			txt5:'未开始',
			monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
			viewurl:'/CostCalc/ActualCsotView/GetSumRunningHourView',
			expurl:'/CostCalc/ActualCsotView/GetSumRunningHourViewToExecl',
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			getPlanStatus: null,
			btn: {
				btn1: false,
				btn2:false,
				btn3:false,
				btn4:false,
				btn5:false,
				btn6:false,
				btnbegin:false,
				btnstop:false,
			}
		};
	},
	beforeDestroy(){
	//console.log('关闭')
		if(!this.$limits.fnIsEmpty(this.getPlanStatus)){
		clearInterval(this.getPlanStatus)
		this.getPlanStatus = null
		}
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		let thisyear = new Date().getFullYear();
		for(let i=0;i<10;i++){
		let obj = {
		value: thisyear-i,
		label:thisyear-i
		};
		that.yearList.push(obj);
		}
		that.dataDetail.cboyear = thisyear;
		that.authority();

		
		

	},
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogicticscsvViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//that.$refs.SetBtn.SetButtonEnable('export',true);
			//that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			//return;

			// //只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
			// 	if (that.total > 0) {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 	} else {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 	}
			// }
			// //操作权限-查询级别
			// limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
			// // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			// switch (limits) {
			// 	case -1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	default:
			// 		break;
			// }
			// if(limits==-1||limits==1)that.closeAllRightButton();
            // else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
			
		},
		closeAllRightButton(){
			let that =this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		NewForm(){
			let that = this;
			let item = {
			label: '成本核算历史',
			name: '3_costhis',
			path: '/costhis',
			url: '/costhis',
			icon: 'video-play'
			};
			this.$router.push({path: '/costhis'});
			this.$store.commit('selectMenu', item);
		},
		//审核汇报工时
		AuditMonth(){
		let that = this;
		let param = {
		TYear: that.dataDetail.cboyear,
		Month: that.dataDetail.cbomonth,
		Confirmflag:0,
            LangType: that.$processdata.getLang()
		}
		that.$http.urlpost('/CostCalc/ActualCsotView/mnuAuditReportManHour', param, function (res) {
		if (res.Success == 1) {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
		}
		});
		},
		//反审核
		InvAuditMonth(){
		let that = this;
		let param = {
		TYear: that.dataDetail.cboyear,
		Month: that.dataDetail.cbomonth,
		Confirmflag:0,
            LangType: that.$processdata.getLang()
		}
		that.$http.urlpost('/CostCalc/ActualCsotView/mnuRAuditReportManHour', param, function (res) {
		if (res.Success == 1) {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
		}
		});
		},
		

		//标定本月成本
		BiaodingMonth(){
		let that = this;
		let param = {
		TYear: that.dataDetail.cboyear,
		Month: that.dataDetail.cbomonth,
		Confirmflag:0,
            LangType: that.$processdata.getLang()
		}
		that.$http.urlpost('/CostCalc/ActualCsotView/mnuConfirmCost', param, function (res) {
		if (res.Success == 1) {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
		}
		});
		},
		//反标定本月成本
		InverseThisMonth(){
		let that = this;
		let param = {
		TYear: that.dataDetail.cboyear,
		Month: that.dataDetail.cbomonth,
		Confirmflag:0,
            LangType: that.$processdata.getLang()
		}
		that.$http.urlpost('/CostCalc/ActualCsotView/mnuRConfirmCost', param, function (res) {
		if (res.Success == 1) {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
		}
		});
		},
		//清除所有在制标定
		ClearBiaoding(){
		let that = this;
		let param = {
		TYear: that.dataDetail.cboyear,
		Month: that.dataDetail.cbomonth,
		Confirmflag:0,
            LangType: that.$processdata.getLang()
		}
		that.$http.urlpost('/CostCalc/ActualCsotView/mnuClearWIPClose', param, function (res) {
		if (res.Success == 1) {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
		}
		});
		},

		getMonthData(){
		let that = this;
		let param = {
		TYear: that.dataDetail.cboyear,
		Month: that.dataDetail.cbomonth,
		}
		that.$http.urlpost('/CostCalc/ActualCsotView/CalcAndConfirmSignShow', param, function (res) {
		if (res.Success == 1) {
			that.IsCaculate=res.DataContent.lblCalcSign;
			that.IsSure=res.DataContent.lblConfirmSign;
			that.btn.btn1=false;
			that.btn.btn2=false;
			that.btn.btn3=false;
			that.btn.btn4=false;
			that.btn.btn5=false;
			that.btn.btn6=false;
			if(that.IsSure=='已标定'){//that.IsCaculate=='已计算'||that.IsCaculate=='未计算')&&
				that.btn.btn5=true;
				that.btn.btn6=true;
			}else if(that.IsSure=='未标定'){
				that.btn.btn1=true;
				that.btn.btn2=true;
				that.btn.btn3=true;
				that.btn.btn4=true;
				that.btn.btn5=true;
				that.btn.btn6=true;
			}


		}
		});


		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SumRunningHourInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.viewurl, data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
			"newmonth": that.copyparam.copyMonth.split("-")[1],
			"newyear": that.copyparam.copyMonth.split("-")[0],
			"oldmonth": that.copyparam.startMonth.split("-")[1],
			"oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		send(){
			let that = this;
			that.loading = true;
			that.$http.urlpost('/CostCalc/PurView/GetLatestPurPriceView', {}, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
				}
				that.loading = false;
			});
		},
		PostCaculate(param){
			let that = this;
			that.txt5 = '计算中...';
			that.$http.urlpost('/CostCalc/ActualCsotView/GetProductCostMainMatch', param, function (res) {
				if(res.Success==2||res.Success==3){
					//提示与返回
					that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
						confirmButtonText: that.$t('getapi[1146]'),
						cancelButtonText: that.$t('getapi[2054]'),
						type: 'warning'
					})
					.then(() => {
						param.Confirmflag = res.Success;
						that.PostCaculate(param);
					})
					.catch(() => {
						that.loading = false;
						that.txt5 = '已取消计算';
						//关闭定时器
						if(!that.$limits.fnIsEmpty(that.getPlanStatus)){
							clearInterval(that.getPlanStatus);
							that.getPlanStatus = null;
						}
						this.$message({
							type: 'info',
							message: that.$t('getapi[6096]')
						});
					});
				}else if(res.Success == 0){
					that.loading = false;
					that.txt5 = '计算结束';
					//关闭定时器
					if(!that.$limits.fnIsEmpty(that.getPlanStatus)){
						clearInterval(that.getPlanStatus);
						that.getPlanStatus = null;
					}
				}
			})
		},
		doCaculate(){
			let that = this;
			if(that.$limits.fnIsEmpty(that.dataDetail.cbomonth)||that.$limits.fnIsEmpty(that.dataDetail.cboyear)){
				that.$message.warning(that.$t('getapi[8783]'));//'年月不能为空'
				return;
			}
			let data={
				TYear: that.dataDetail.cboyear,
				Month: that.dataDetail.cbomonth,
				Confirmflag: 0,
				LangType: that.$processdata.getLang()
			}
			that.loading = true;
			//当前计算年月
			that.txt1 = that.dataDetail.cboyear+'年-'+that.dataDetail.cbomonth+'月';
			//开始计算时间
			that.txt3=that.$limits.getDateTime();
			//开启定时器

			that.PostCaculate(data);

			//开始询问计算是否完成
			that.getPlanStatus = setInterval(() => {
			that.$http.urlpost('/CostCalc/ActualCsotView/GetProductCostMainMatchClose', '', function (res) {
				if (res.Success == 1) {
					if(!that.$limits.fnIsEmpty(res.Key)){
						that.$message.success(that.$t('getapi[6431]'));//"计算完成"
						//Msg.服务器结束时间
						that.txt4 = that.$processdata.explainCallbackMsg(res.Msg);
						that.txt5 = '本次计算完成';
						//关闭定时器
						if(!that.$limits.fnIsEmpty(that.getPlanStatus)){
							clearInterval(that.getPlanStatus);
							that.getPlanStatus = null;
							that.loading = false;
						}
					}
				}
				else{
					//关闭定时器
					if(!that.$limits.fnIsEmpty(that.getPlanStatus)){
						clearInterval(that.getPlanStatus);
						that.getPlanStatus = null;
					}
					that.loading = false;
				}
			});
			}, 5000);

			
			
		},
		
		print(){
			let that = this;
			let parm = {
			po_no: '',
			TemplateName: '08Invoice_CSV.xlsx'
			};

			for(let i=0;i<that.selectIDList.length;i++){
			parm.po_no= parm.po_no + "'"+that.selectIDList[i].exclusively_id+"',";
			}
			parm.po_no =  parm.po_no.substring(0, parm.po_no.length - 1);

			that.btn.print = false;
			that.loading = true;
			that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
			that.btn.print = true;
			if (res.Success == 1) {
			let hrefurl = res.Key;
			window.open(hrefurl);
			} 
			that.loading = false;
			});
		},
		deleteline(){
			let that = this;
			let parm = {
				Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
			};
			that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function(res) {
				if (res.Success == 1) {
					that.reflash();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
				}
			});

		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.expurl, data, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
